module.exports = __webpack_public_path__ + "img/advanced-layout.6929570f.svg";